import { lazy } from "react";
import MyGamesPage from "routes/my-games/mobile/MyGamesPage";

export const commonRoutes = [
  {
    path: "/login",
    exact: true,
    component: lazy(() => import("routes/auth/login")),
  },
  {
    path: "/auth/callback",
    exact: true,
    component: lazy(() => import("components/clients/Go3/Go3AuthCallback")),
  },
  {
    path: "/signup",
    exact: true,
    component: lazy(() => import("routes/auth/signup")),
  },
  {
    path: "/forgetpassword",
    exact: true,
    component: lazy(() => import("routes/auth/forget-password")),
  },
  {
    path: "/verifyotp",
    exact: true,
    component: lazy(() => import("routes/auth/verify-otp")),
  },
  {
    path: "/resetpassword",
    exact: true,
    component: lazy(() => import("routes/auth/reset-password")),
  },
  {
    path: "/tournaments/faq",
    exact: true,
    component: lazy(() => import("routes/information/faq")),
  },
  {
    path: "/tournaments/privacypolicy",
    exact: true,
    component: lazy(() => import("routes/information/privacy-policy")),
  },

  {
    path: "/tournaments/contact-us",
    exact: true,
    component: lazy(() => import("routes/information/contact-us")),
  },
  {
    path: "/tournaments/terms-and-conditions",
    exact: true,
    component: lazy(() => import("routes/information/terms-and-conditions")),
  },
  {
    path: "/profile",
    exact: true,
    component: lazy(() => import("routes/user/profile/index")),
  },
  {
    path: "/arcade",
    exact: true,
    component: lazy(() => import("routes/arcade")),
  },
  {
    path: "/tournament/heroes-section",
    exact: true,
    component: lazy(() => import("routes/heroes-section")),
  },

  {
    path: "/tournament-history",
    exact: true,
    component: lazy(() => import("routes/tournaments/tournament-history")),
  },
  {
    path: "/tickets",
    exact: true,
    component: lazy(() => import("routes/tickets")),
  },
  {
    path: "/ticket-rewards",
    exact: true,
    component: lazy(() => import("routes/tickets/rewards")),
  },
  {
    path: "/token-profile",
    exact: true,
    component: lazy(() => import("routes/tokens")),
  },
  {
    path: "/redeem",
    exact: true,
    component: lazy(() => import("routes/tokens/redeem")),
  },
  {
    path: "/ticket-redeem",
    exact: true,
    component: lazy(() => import("routes/tickets/redeem")),
  },
  {
    path: "/achievement",
    exact: true,
    component: lazy(() => import("routes/achievements")),
  },
  {
    path: "/reward",
    exact: true,
    component: lazy(() => import("routes/rewards")),
  },
  {
    path: "/notifications",
    exact: true,
    component: lazy(() => import("routes/notifications")),
  },
  {
    path: "/tournament/missions",
    exact: true,
    component: lazy(() => import("routes/missions")),
  },
  {
    path: "/cta-page",
    exact: true,
    component: lazy(() => import("routes/cta")),
  },
  {
    path: "/partner-balance",
    exact: true,
    component: lazy(() => import("routes/partner/balance")),
  },
  {
    path: "/nurture",
    exact: true,
    component: lazy(() => import("routes/nurture")),
  },
  {
    path: "/monopoly-landing",
    exact: true,
    component: lazy(() => import("routes/monopoly")),
  },
  {
    path: "/monopoly",
    exact: false,
    component: lazy(() => import("routes/monopoly/MonopolyGamePage")),
  },
  {
    path: "/nftazos",
    exact: true,
    component: lazy(() => import("routes/nftazos/pages/Battles")),
  },
  {
    path: "/nftazos/pvp/:tournament",
    exact: true,
    component: lazy(() => import("routes/nftazos/pages/PVP")),
  },
  {
    path: "/coin-purchase",
    exact: true,
    component: lazy(() => import("routes/coin-purchase")),
  },
];

export const desktopRoutes = [
  {
    path: "/",
    component: lazy(() => import("routes/home/desktop")),
  },
  {
    path: "/tournament",
    exact: true,
    component: lazy(() => import("routes/home/desktop")),
  },
  ...commonRoutes,
  {
    path: "/tournament/play-featured-game",
    exact: true,
    component: lazy(() => import("routes/tournaments/desktop/FeaturedGameDirectPlay")),
  },
  {
    path: "/tournament/play-featured-game/:serial",
    exact: true,
    component: lazy(() => import("routes/tournaments/desktop/FeaturedGameDirectPlay")),
  },
  {
    path: "/tournaments/:tournamentId/play",
    exact: true,
    component: lazy(() => import("routes/play-game/tournament/desktop/play")),
  },
  {
    path: "/pvp-page/:tournamentId",
    exact: true,
    component: lazy(() => import("routes/play-game/pvp/mobile/desktop/PlayerVsPlayer")),
  },
  {
    path: "/arcade/categories/:categoryId",
    exact: true,
    component: lazy(() => import("routes/arcade/desktop/CategoryArcadePage")),
  },
  {
    path: "/C2PplayGamePage",
    exact: true,
    component: lazy(() => import("routes/play-game/arcade/desktop/ArcadePlayGamePage")),
  },
  {
    path: "/C2PplayGamePage/:slug",
    exact: true,
    component: lazy(() => import("routes/play-game/arcade/desktop/ArcadePlayGamePage")),
  },
  {
    path: "/pvp/tournaments/:gameSlug",
    exact: true,
    component: lazy(() => import("routes/pvp/desktop/PVPTournamentList")),
  },
];

export const mobileRoutes = [
  {
    path: "/",
    exact: true,
    component: lazy(() => import("routes/home/mobile")),
    componentTwo: lazy(() => import("routes/home/mobile/single-featured-game")),
  },
  {
    path: "/tournament",
    exact: true,
    component: lazy(() => import("routes/home/mobile")),
    componentTwo: lazy(() => import("routes/home/mobile/single-featured-game")),
  },
  ...commonRoutes,
  /* {
    path: "/tournaments/:tournamentId",
    exact: true,
    component: lazy(() => import("routes/tournaments/mobile/TournamentDetails")),
  }, */
  {
    path: "/tournaments/:tournamentId/play/:init?",
    exact: true,
    component: lazy(() => import("routes/play-game/tournament/mobile/play")),
  },
  {
    path: "/C2PplayGamePage",
    exact: true,
    component: lazy(() => import("routes/play-game/arcade/mobile/ArcadePlayGamePage")),
  },
  {
    path: "/C2PplayGamePage/:slug",
    exact: true,
    component: lazy(() => import("routes/play-game/arcade/mobile/ArcadePlayGamePage")),
  },
  {
    path: "/arcade/categories/:categoryId",
    exact: true,
    component: lazy(() => import("routes/arcade/mobile/CategoryArcadePage")),
  },
  {
    path: "/pvp-page/:tournamentId",
    exact: true,
    component: lazy(() => import("routes/play-game/pvp/mobile/PlayerVsPlayer")),
  },
  {
    path: "/pvp/tournaments/:gameSlug",
    exact: true,
    component: lazy(() => import("routes/pvp/mobile/PvpTournamentList")),
  },
  {
    path: "/pvp/games/:gameSlug",
    exact: true,
    component: lazy(() => import("routes/tournaments/mobile/GameWiseTournamentList")),
  },
  {
    path: "/games/:gameSlug",
    exact: true,
    component: lazy(() => import("routes/tournaments/mobile/GameWiseTournamentList")),
  },
  {
    path: "/tournament/play-featured-game",
    exact: true,
    component: lazy(() => import("routes/tournaments/mobile/FeaturedGameDirectPlayPage")),
  },
  {
    path: "/tournament/play-featured-game/:serial",
    exact: true,
    component: lazy(() => import("routes/tournaments/mobile/FeaturedGameDirectPlayPage")),
  },
  {
    path: "/tournament/my-games",
    exact: true,
    component: MyGamesPage,
  },
];

export const routes = {
  commonRoutes,
  mobileRoutes,
  desktopRoutes,
  allRoutes: [...commonRoutes, ...mobileRoutes, ...desktopRoutes],
};

export default routes;
